import { useState } from "react";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation, Link } from "react-router-dom";
// import { Menu } from '../../../components/menu-consultas'

export const LayoutConsultasIntegradas: React.FC = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawerOpen = (): void => setDrawerOpen(!drawerOpen);
  const { pathname } = useLocation();

  const theme = MUI.useTheme();
  const mdDown = MUI.useMediaQuery(theme.breakpoints.down("md"));
  return (
    <MUI.Stack pt={[2, 0]} flexDirection="row" width="100%" height="80vh">
      {mdDown ? (
        <MUI.Box>
          <MUI.IconButton onClick={toggleDrawerOpen}>
            <Icon.Menu />
          </MUI.IconButton>
          <MUI.Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawerOpen}
          >
            <MUI.Box
              display="flex"
              flexDirection="column"
              height="100%"
              width={theme.spacing(28)}
              bgcolor={theme.palette.primary.light}
            >
              <MUI.Box>
                <MUI.List>
                  <MUI.Typography
                    sx={{ color: "#fff !important" }}
                    variant="h6"
                    textAlign="center"
                  >
                    Consultas Integradas
                  </MUI.Typography>

                  <MUI.ListItemButton
                    component={Link}
                    to="/consultas-integradas/consulta-nominal"
                    selected={
                      pathname === "/consultas-integradas/consulta-nominal"
                    }
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: `${theme.palette.primary.main}`,
                        "&.Mui-focusVisible": {
                          backgroundColor: `${theme.palette.primary.dark}`,
                        },
                        ":hover": {
                          backgroundColor: `${theme.palette.primary.dark}`,
                        },
                      },
                    }}
                  >
                    <MUI.ListItemIcon>
                      <Icon.PersonSearch sx={{ color: "white" }} />
                    </MUI.ListItemIcon>
                    <MUI.ListItemText sx={{ color: "white" }}>
                      Consulta
                    </MUI.ListItemText>
                  </MUI.ListItemButton>

                  <MUI.ListItemButton component={Link} to="/pagina-inicial">
                    <MUI.ListItemIcon>
                      <Icon.KeyboardReturn sx={{ color: "white" }} />
                    </MUI.ListItemIcon>
                    <MUI.ListItemText sx={{ color: "white" }}>
                      Voltar página inicial
                    </MUI.ListItemText>
                  </MUI.ListItemButton>
                </MUI.List>
              </MUI.Box>

              <MUI.Stack flex={1} padding={2}>
                <MUI.Typography sx={{ color: "#fff !important" }} variant="h6">
                  LEGENDA
                </MUI.Typography>
                <MUI.Stack flexDirection="row" gap={1} mb={1}>
                  <MUI.Stack
                    width={17}
                    height={17}
                    sx={{
                      borderColor: "white",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                    bgcolor="purple"
                  />
                  <MUI.Typography
                    fontWeight="bold"
                    variant="body2"
                    sx={{ color: "#fff !important" }}
                  >
                    ALERTA
                  </MUI.Typography>
                </MUI.Stack>
                <MUI.Stack flexDirection="row" gap={1} mb={1}>
                  <MUI.Stack
                    width={17}
                    height={17}
                    sx={{
                      borderColor: "white",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                    bgcolor="blue"
                  />
                  <MUI.Typography
                    fontWeight="bold"
                    variant="body2"
                    sx={{ color: "#fff !important" }}
                  >
                    CIVIL
                  </MUI.Typography>
                </MUI.Stack>
                <MUI.Stack flexDirection="row" gap={1} mb={1}>
                  <MUI.Stack
                    width={17}
                    height={17}
                    sx={{
                      borderColor: "white",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                    bgcolor="red"
                  />
                  <MUI.Typography
                    fontWeight="bold"
                    variant="body2"
                    sx={{ color: "#fff !important" }}
                  >
                    CRIMINAL
                  </MUI.Typography>
                </MUI.Stack>
                <MUI.Stack flexDirection="row" gap={1} mb={1}>
                  <MUI.Stack
                    width={17}
                    height={17}
                    sx={{
                      borderColor: "white",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                    bgcolor="green"
                  />
                  <MUI.Typography
                    fontWeight="bold"
                    variant="body2"
                    sx={{ color: "#fff !important" }}
                  >
                    CARCERÁRIO
                  </MUI.Typography>
                </MUI.Stack>
                {/* <MUI.Stack flexDirection="row" gap={1} mb={1}>
                  <MUI.Stack
                    width={17}
                    height={17}
                    sx={{
                      borderColor: "white",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                    bgcolor="yellow"
                  />
                  <MUI.Typography
                    fontWeight="bold"
                    variant="body2"
                    sx={{ color: "#fff !important" }}
                  >
                    MANDADO
                  </MUI.Typography>
                </MUI.Stack> */}
                <MUI.Stack flexDirection="row" gap={1} mb={1}>
                  <MUI.Stack
                    width={17}
                    height={17}
                    sx={{
                      borderColor: "white",
                      borderWidth: "1px",
                      borderStyle: "solid",
                    }}
                    bgcolor="orange"
                  />
                  <MUI.Typography
                    fontWeight="bold"
                    variant="body2"
                    sx={{ color: "#fff !important" }}
                  >
                    VEÍCULO
                  </MUI.Typography>
                </MUI.Stack>
              </MUI.Stack>
            </MUI.Box>
          </MUI.Drawer>
        </MUI.Box>
      ) : (
        <MUI.Box
          display="flex"
          flexDirection="column"
          height="100%"
          width={theme.spacing(30)}
          bgcolor={theme.palette.primary.light}
        >
          <MUI.Box mb={3}>
            <MUI.List>
              <MUI.Typography
                sx={{ color: "#fff !important" }}
                variant="h6"
                textAlign="center"
              >
                Consultas Integradas
              </MUI.Typography>

              <MUI.ListItemButton
                component={Link}
                to="/consultas-integradas/consulta-nominal"
                selected={pathname === "/consultas-integradas/consulta-nominal"}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: `${theme.palette.primary.main}`,
                    "&.Mui-focusVisible": {
                      backgroundColor: `${theme.palette.primary.dark}`,
                    },
                    ":hover": {
                      backgroundColor: `${theme.palette.primary.dark}`,
                    },
                  },
                }}
              >
                <MUI.ListItemIcon>
                  <Icon.PersonSearch sx={{ color: "white" }} />
                </MUI.ListItemIcon>
                <MUI.ListItemText sx={{ color: "white" }}>
                  Consulta
                </MUI.ListItemText>
              </MUI.ListItemButton>

              <MUI.ListItemButton component={Link} to="/pagina-inicial">
                <MUI.ListItemIcon>
                  <Icon.KeyboardReturn sx={{ color: "white" }} />
                </MUI.ListItemIcon>
                <MUI.ListItemText sx={{ color: "white" }}>
                  Voltar página inicial
                </MUI.ListItemText>
              </MUI.ListItemButton>
            </MUI.List>
          </MUI.Box>
          <MUI.Stack flex={1} padding={2}>
            <MUI.Typography sx={{ color: "#fff !important" }} variant="h6">
              LEGENDA
            </MUI.Typography>
            <MUI.Stack flexDirection="row" gap={1} mb={1}>
              <MUI.Stack
                width={17}
                height={17}
                sx={{
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                bgcolor="purple"
              />
              <MUI.Typography
                fontWeight="bold"
                variant="body2"
                sx={{ color: "#fff !important" }}
              >
                ALERTA
              </MUI.Typography>
            </MUI.Stack>
            <MUI.Stack flexDirection="row" gap={1} mb={1}>
              <MUI.Stack
                width={17}
                height={17}
                sx={{
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                bgcolor="blue"
              />
              <MUI.Typography
                fontWeight="bold"
                variant="body2"
                sx={{ color: "#fff !important" }}
              >
                CIVIL
              </MUI.Typography>
            </MUI.Stack>
            <MUI.Stack flexDirection="row" gap={1} mb={1}>
              <MUI.Stack
                width={17}
                height={17}
                sx={{
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                bgcolor="red"
              />
              <MUI.Typography
                fontWeight="bold"
                variant="body2"
                sx={{ color: "#fff !important" }}
              >
                CRIMINAL
              </MUI.Typography>
            </MUI.Stack>
            <MUI.Stack flexDirection="row" gap={1} mb={1}>
              <MUI.Stack
                width={17}
                height={17}
                sx={{
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                bgcolor="green"
              />
              <MUI.Typography
                fontWeight="bold"
                variant="body2"
                sx={{ color: "#fff !important" }}
              >
                CARCERÁRIO
              </MUI.Typography>
            </MUI.Stack>
            {/* <MUI.Stack flexDirection="row" gap={1} mb={1}>
              <MUI.Stack
                width={17}
                height={17}
                sx={{
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                bgcolor="yellow"
              />
              <MUI.Typography
                fontWeight="bold"
                variant="body2"
                sx={{ color: "#fff !important" }}
              >
                MANDADO
              </MUI.Typography>
            </MUI.Stack> */}
            <MUI.Stack flexDirection="row" gap={1} mb={1}>
              <MUI.Stack
                width={17}
                height={17}
                sx={{
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                bgcolor="orange"
              />
              <MUI.Typography
                fontWeight="bold"
                variant="body2"
                sx={{ color: "#fff !important" }}
              >
                VEÍCULO
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
        </MUI.Box>
      )}
      <MUI.Stack flex={1} padding={2} gap={1} overflow="auto">
        {children}
      </MUI.Stack>
    </MUI.Stack>
  );
};
